import React, { useState } from 'react';
import Header from './header.jsx'
import LeftNav from './LeftNav.jsx';
import { Outlet } from 'react-router-dom';

const AdminSettings = () => {
  return (
    <>
      <div className='admin'>
        <Header />
        <LeftNav />
        <div className='admin__container'>
          <Outlet />
        </div>
      </div>
    </>
  );
};

export default AdminSettings;